var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "LayoutPublic" }, [
    _c("header", { staticClass: "p-4", attrs: { role: "banner" } }, [
      _c(
        "div",
        { staticClass: "logo mx-auto" },
        [_c("UiBrandLogoWide", { attrs: { isDark: true } })],
        1
      ),
      _vm._v(" "),
      _vm.showLang
        ? _c(
            "div",
            { staticClass: "position-fixed top-0 right-0 pr-3 pt-3" },
            [_c("LanguageSelection")],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "main",
      {
        staticClass: "page-content container",
        style: { maxWidth: _vm.containerWidth + "px" },
      },
      [_c("UiCard", { staticClass: "p-4" }, [_vm._t("default")], 2)],
      1
    ),
    _vm._v(" "),
    _c(
      "footer",
      { staticClass: "page-footer text-center text-white py-4 px-3" },
      [
        _c("span", {
          domProps: { innerHTML: _vm._s(_vm.$t("public_page.footer_text")) },
        }),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "underline text-warning",
            attrs: { href: "http://" + _vm.website, target: "_blank" },
          },
          [_vm._v(_vm._s(_vm.website))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }